import { RouteRecordRaw } from 'vue-router'

const voyagesRoutes: RouteRecordRaw[] = [
  {
    path: '/crew/voyages',
    name: 'voyages.index',
    component: () => import('@/modules/crewing/views/voyages/VoyagesIndex.vue'),
    meta: {
      pageTitle: 'Voyages',
      breadcrumbs: ['Voyages']
    }
  },
  {
    path: '/crew/voyages/:id',
    name: 'voyages.show',
    component: () => import('@/modules/crewing/views/voyages/VoyageShow.vue'),
    meta: {
      pageTitle: 'Voyage',
      breadcrumbs: ['Voyages', 'Voyage']
    }
  }
]

export default voyagesRoutes
